import React from 'react';

const ComingSoon = () => (
  <p style={{ textAlign: 'center', fontSize: '0.85rem' }}>
    <strong>Coming Soon!</strong>
  </p>
);

export default ComingSoon;
